import React from 'react';
import moment from 'moment';
import TagChip from './tag_chip';

const ArticuloMetadata = ({articulo}) => {

  // return <>
  //   <div>Metadata</div>
  // </>

  return <>
  <div style={{ fontSize: "95%", color: "#8a8a8a", marginBottom: 24 }}>
  {articulo?.autores &&
    articulo.autores.length > 0 && (
      <p style={{ marginTop: 24, marginBottom: 0 }}>
        {articulo.autores.length > 1 ? "Autores" : "Autor"}:{" "}
        {articulo.autores.map(a => a.displayName).join(', ')}
      </p>
    )}
  {articulo?.creado && (
    <p style={{ marginTop: 0, marginBottom: 0 }}>
      Creado: {moment(articulo.creado).format("LLL")} hrs.
    </p>
  )}
  {articulo?.modificado && (
    <p style={{ marginTop: 0, marginBottom: 0 }}>
      Modificado: {moment(articulo.modificado).format("LLL")}{" "}
      hrs.
    </p>
  )}
</div>
{articulo?.etiquetas &&
            articulo.etiquetas.length > 0 &&
            articulo.etiquetas.map((tag) => (
              <TagChip key={tag} tag={tag} />
            ))}

</>
}

export default ArticuloMetadata